<div class="flex min-w-0 flex-col gap-4 px-6 py-2 pb-6">
  <div class="inline-flex w-full items-end justify-between px-4">
    <div class="textTabsColor font-['Inter'] text-2xl font-semibold" i18n="@@incomingProductsTitle">
      Incoming Products
    </div>
  </div>

  @if (isLoading()) {
    <app-loading />
  } @else if (hasError()) {
    <div class="py-8">
      <app-error-data
        title="Something went wrong"
        i18n-title="@@errorTitle"
        description="We couldn't load the products right now. Please try again later."
        i18n-description="@@errorDescription"
        [showRetry]="true"
        (retry)="loadIncomingProducts()"></app-error-data>
    </div>
  } @else {
    <div class="grid w-full grid-cols-1 gap-4 px-8 sm:grid-cols-2 lg:grid-cols-4">
      @for (product of products(); track product.productId) {
        <app-product-card-component
          [product]="product"
          (activePopup)="onActiveAddToCartPopup($event)"
          (addToWishlist)="onAddToWishlist($event)" />
      }
    </div>
  }

  <div class="mt-6 flex w-full items-center justify-center">
    <a
      routerLink="/user/products"
      class="bgTabsColor hover-bg-primary-hover flex items-center justify-center rounded-lg px-6 py-2 font-['Inter'] text-base font-medium text-white transition-all active:scale-95"
      i18n="@@incomingProductsViewAll">
      View All
    </a>
  </div>
</div>

@if (addToCartPopup()) {
  <!-- (click)="closePopup($event)" -->
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div class="relative w-[340px] rounded-2xl border border-gray-100 bg-white p-6" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="mb-5 flex items-center gap-3">
        <div class="primaryTextColor flex h-9 w-9 items-center justify-center rounded-lg bg-green-50">
          <app-cart-icon type="add" />
        </div>
        <div>
          <p class="primaryTextColor text-sm font-medium" i18n="@@updateQuantity">Update quantity</p>
        </div>
      </div>

      <!-- Quantity -->
      <label class="mb-2 block text-xs text-gray-500" i18n="@@quantity">Quantity</label>
      <div class="mb-5 flex w-fit items-center overflow-hidden rounded-lg border border-gray-200">
        <button
          (click)="increaseQty()"
          class="flex h-9 w-9 cursor-pointer items-center justify-center border-r border-gray-100 bg-gray-50 outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 13h8v8h2v-8h8v-2h-8V3h-2v8H3z" />
          </svg>
        </button>
        <input
          [(ngModel)]="itemQuantity"
          (ngModelChange)="onQuantityChange($event)"
          (change)="errorQuantity()"
          type="number"
          class="h-9 w-13 border-none text-center text-sm font-medium outline-none" />
        <button
          (click)="decreaseQty()"
          class="flex h-9 w-9 cursor-pointer items-center justify-center border-l border-gray-100 bg-gray-50 outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 11h18v2H3z" />
          </svg>
        </button>
      </div>

      @if (errorQty()) {
        <p class="mb-2 text-xs font-light text-red-500">
          {{ errorQty() }}
        </p>
      }

      <!-- Total -->
      <div class="mb-4 flex items-center justify-between border-t border-gray-100 py-2.5">
        <span class="text-xs text-gray-400" i18n="@@thTotalPrice">Total</span>
        <span class="rtl text-base font-medium text-gray-900" dir="rtl">
          {{ addToCartPopup()?.productPrice | currency: "EGP" : "symbol" : "1.2-2" : "ar-EG" }}
        </span>
      </div>

      @if (isErrorCart()) {
        <div class="my-4">
          <app-error [apiError]="isErrorCart()" />
        </div>
      }

      <!-- Actions -->
      <div class="flex gap-2">
        <button
          class="h-9 flex-1 cursor-pointer rounded-lg border border-gray-200 text-sm text-gray-500"
          i18n="@@cancel"
          (click)="addToCartPopup.set(null)">
          Cancel
        </button>
        <button
          (click)="onAddToCart()"
          class="bgPrimary h-9 flex-1 cursor-pointer rounded-lg border border-gray-200 text-sm font-medium text-white">
          @if (isAddingToCart()) {
            <span i18n="@@loading">loading...</span>
          } @else {
            <span i18n="@@addToCart">Add To Cart</span>
          }
        </button>
      </div>
    </div>
  </div>
}
